import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

import Demo from "@/modules/demo/Demo";

import projects from "@/modules/projects/routing";
import viewer from "@/modules/viewer/routing";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'demo',
            component: Demo
        },
        {
            path: '/scene/:sid',
            component: () => import("@/modules/main/MainPage"),
            children: [
                projects,
                viewer
            ],
        }
    ]
});

router.afterEach((to) => {

    const matching = to.matched[0];

    const props = matching ? matching.props.default : {};

    const data = {
        name: to.name,
        path: to.path,
        fullPath: to.fullPath,
        params: to.params,
        props: props,
    };

    store.dispatch('context/setRoute', data);
});
export default router;